import React from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Form } from 'react-final-form';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { Content } from '../../../infrastructure/content';
import RegisteredName from '../../aboutBusinessQuestion/components/RegisteredName';
import RegisteredNumber from '../../aboutBusinessQuestion/components/RegisteredNumber';
import TradingName from '../../aboutBusinessQuestion/components/TradingName';
import IndustryComponent from '../../aboutBusinessQuestion/components/IndustryComponent';
import ActivityTypes from '../../aboutBusinessQuestion/components/ActivityTypes';
import NeedLicence from '../../aboutBusinessQuestion/components/NeedLicence';
import NumberOfPeople from '../../aboutBusinessQuestion/components/NumberOfPeople';
import DateField from '../../../components/DateField';
import TypeOfLicense from '../../aboutBusinessQuestion/components/TypeOfLicense';
import {
  renderRegisterAddress,
  renderTradingAddress,
  renderMailingAddress
} from '../../aboutBusinessQuestion/components/AddressComponents/GetAddresses';
import {
  REGISTER_ADDRESS_TYPE,
  TRADING_ADDRESS_TYPE,
  DIFFERENT_ADDRESS_TYPE,
  MAILING_ADDRESS_TYPE,
  MULTIPLE_ADDRESS_TRADING,
  MULTIPLE_ADDRESS_MAILING,
  REGISTER_ADDRESS_SELECTOR
} from '../../../utils/constants';
import { getSelectedAddress } from '../../../components/Address/addressUtils/addressUtils';
import { onKeyPress } from '../../../utils';
import {
  getInitialValues,
  getInitialValuesMultiParty,
  setAboutBusinessSubmitted,
  isAboutBusinessFormSubmitted
} from '../../aboutBusinessQuestion/utils/aboutBusinessPageUtils';

class AboutYourBusinessAccordionItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      registerEditClick: true,
      tradingEditClick: true,
      mailingEditClick: true
    };
    setAboutBusinessSubmitted();
    this.saveAboutBusinessChanges = this.saveAboutBusinessChanges.bind(this);
    this.aboutBusinessEditClick = this.aboutBusinessEditClick.bind(this);
    this.getExistingAddres = this.getExistingAddres.bind(this);
  }
  aboutBusinessEditClick() {
    this.setState({ isEdit: !this.state.isEdit });
    this.props.editClick(!this.state.isEdit);
    this.props.onValueChanges(false);
  }

  getExistingAddres(type) {
    switch (type) {
      case REGISTER_ADDRESS_TYPE:
        return this.props.editButtonClicks.registerEditClick ? this.props.registerAddress : '';
      case TRADING_ADDRESS_TYPE:
        return this.props.editButtonClicks.tradingEditClick ? this.props.tradingAddress : '';
      default:
        return '';
    }
  }
  renderAboutBusinessType(values) {
    const {
      getBusinessData,
      isSoleBusinessType,
      address,
      registerAddressValue,
      onAddressSelection,
      tradingAddressValue,
      mailingAddressValue,
      editButtonClicks,
      onAddressEditClick,
      saveAboutYourFormValues
    } = this.props;
   
    if (!this.state.isEdit) {
      const getDescriptionList = (
        registeredCompanyName,
        registeredNumber,
        registeredDate,
        tradingName,
        industryName,
        industryDescription,
        needLicence,
        numberOfPeople,
        registerAddress,
        mailingAddress,
        tradingAddress
      ) => {
        const items = [];
        if (!isSoleBusinessType) {
          items.push({ key: registeredCompanyName, value: getBusinessData.registeredName });
          items.push({ key: registeredNumber, value: getBusinessData.registeredNumber });
          items.push({
            key: registerAddress,
            value: getSpittedAddress(
              getSelectedAddress(getBusinessData, 'register', address, registerAddressValue)
            )
          });
          items.push({
            key: registeredDate,
            value: getBusinessData.incorporationDate
              ? `${getBusinessData.incorporationDate.dateField}-${getBusinessData.incorporationDate.monthField}-${getBusinessData.incorporationDate.yearField}`
              : ''
          });
        }
        items.push({ key: tradingName, value: getBusinessData.tradingName });
        items.push({
          key: tradingAddress,
          value: getBusinessData.mutipleAddressTrading
            ? getSpittedAddress(
                getSelectedAddress(
                  getBusinessData,
                  checkForDifferentAddressType(
                    getBusinessData.mutipleAddressTrading,
                    TRADING_ADDRESS_TYPE
                  ),
                  address,
                  tradingAddressValue
                )
              )
            : getSpittedAddress(tradingAddressValue)
        });
        items.push({
          key: mailingAddress,
          value: getBusinessData.mutipleAddressMailing
            ? getSpittedAddress(
                getSelectedAddress(
                  getBusinessData,
                  checkForDifferentAddressType(
                    getBusinessData.mutipleAddressMailing,
                    MAILING_ADDRESS_TYPE
                  ),
                  address,
                  mailingAddressValue
                )
              )
            : getSpittedAddress(mailingAddressValue)
        });
        items.push({ key: industryName, value: getBusinessData.industryType });
        items.push({ key: industryDescription, value: getBusinessData.industryDescription });
        items.push({ key: needLicence, value: getBusinessData.needLicence });
        items.push({ key: numberOfPeople, value: getBusinessData.numberOfPeople });
        return items;
      };
      return (
        <Content>
          {({
            registeredCompanyName,
            registeredNumber,
            registeredDate,
            tradingName,
            industryName,
            industryDescription,
            needLicence,
            numberOfPeople,
            registerAddress,
            mailingAddress,
            tradingAddress
          }) => (
            <div>
              <GenericDescriptionList
                items={getDescriptionList(
                  registeredCompanyName,
                  registeredNumber,
                  registeredDate,
                  tradingName,
                  industryName,
                  industryDescription,
                  needLicence,
                  numberOfPeople,
                  registerAddress,
                  mailingAddress,
                  tradingAddress
                )}
              />
            </div>
          )}
        </Content>
      );
    }
    const tadingAddressSelection = (name, value) => {
      onAddressSelection(name, value);
      saveAboutYourFormValues({ name: MULTIPLE_ADDRESS_TRADING, value });
    };

    const mailingAddressSelection = (name, value) => {
      onAddressSelection(name, value);
      saveAboutYourFormValues({ name: MULTIPLE_ADDRESS_MAILING, value });
    };
    const registeredAddressSelection = (name, value) => {
      onAddressSelection(name, value);
      saveAboutYourFormValues({ name: REGISTER_ADDRESS_SELECTOR, value });
    };
    const saveFormValues = (name, value) => {
      saveAboutYourFormValues({ name, value });
    };
    return (
      <div>
        {!isSoleBusinessType && (
          <div>
            <RegisteredName isSubmitted={isAboutBusinessFormSubmitted()}  onChange={(name, value) => {
                        saveAboutYourFormValues({ name, value });
                      }}/>
            <RegisteredNumber isSubmitted={isAboutBusinessFormSubmitted()} onChange={(name, value) => {
                        saveAboutYourFormValues({ name, value });
                      }}/>
            {renderRegisterAddress(
              registerAddressValue,
              editButtonClicks.registerEditClick,
              address,
              registeredAddressSelection,
              values,
              onAddressEditClick,
              saveFormValues
            )}
            <DateField
              isSubmitted={isAboutBusinessFormSubmitted()}
              dateHeader="incorporationDate"
              label="registeredDate"
            />
          </div>
        )}
        <TradingName values={values} businessType={isSoleBusinessType}  onChange={(name, value) => {
                    saveAboutYourFormValues({ name, value });
                  }} />
        {renderTradingAddress(
          tradingAddressValue,
          editButtonClicks.tradingEditClick,
          address,
          tadingAddressSelection,
          values,
          isSoleBusinessType,
          onAddressEditClick,
          this.getExistingAddres,
          saveFormValues
          
        )}
        {renderMailingAddress(
          mailingAddressValue,
          editButtonClicks.mailingEditClick,
          address,
          mailingAddressSelection,
          values,
          isSoleBusinessType,
          onAddressEditClick,
          this.getExistingAddres,
          saveFormValues
        )}
        <IndustryComponent isSubmitted={isAboutBusinessFormSubmitted()} formFieldValues={values} 
         onChange={(name, value) => {
          saveAboutYourFormValues({ name, value });
        }}/>
        <ActivityTypes isSubmitted={isAboutBusinessFormSubmitted()} formFieldValues={values} 
        onChange={(name, value) => {
          saveAboutYourFormValues({ name, value });
        }}/>
        <NeedLicence values={values} saveAboutYourFormValues={saveAboutYourFormValues}/>
        {values.needLicence === 'Yes' && <TypeOfLicense values={values}  onChange={(name, value) => {
                      saveAboutYourFormValues({ name, value });
                    }}/>}
        <NumberOfPeople isSubmitted={isAboutBusinessFormSubmitted()}  onChange={(name, value) => {
                    saveAboutYourFormValues({ name, value });
                  }}/>
      </div>
    );
  }
  saveAboutBusinessChanges(e) {
    this.props.saveAboutBusinessChanges(e);
    this.setState({ isEdit: !this.state.isEdit });
    this.props.editClick(!this.state.isEdit);
    this.props.onValueChanges(true);
  }
  render() {
    const {
      getBusinessData,
      onValueChanges,
      linkCode,
      saveAboutYourFormValues,
      isSoleBusinessType,
      onCancelEditClick
    } = this.props;
    const { isEdit } = this.state;    
    return (
      <div>
        <Form
          onSubmit={this.saveAboutBusinessChanges}
          initialValues={
            isSoleBusinessType
              ? getInitialValues(getBusinessData)
              : getInitialValuesMultiParty(getBusinessData)
          }
          render={({ handleSubmit, values }) => (
            <form
              onSubmit={handleSubmit}
              onKeyPress={onKeyPress}
              onChange={(e) => {
                onValueChanges(true);
                e.target &&
                e.target.name &&
                e.target.name.includes('incorporationDate') &&
                saveAboutYourFormValues({ name: e.target.name, value: e.target.value });                
              }}
            >
              {this.renderAboutBusinessType(values)}
              {isEdit && (
                <Content>
                  {({ confirmChanges, changesNotSavedText }) => (
                    <div className="u-margin-top-2 u-margin-bottom-2">
                      <ActionButton.Primary
                        labelText={confirmChanges}
                        onClick={() => this.saveAboutBusinessChanges(values)}
                      />
                      <p>{changesNotSavedText}</p>
                    </div>
                  )}
                </Content>
              )}
            </form>
          )}
        />
        {!linkCode && (
          <div className="u-margin-bottom-2">
            <NavigationButton.Tertiary
              labelText={!isEdit ? 'Edit' : 'Cancel Editing'}
              onClick={(e) => {
                e.preventDefault();

                if (isEdit) {
                  onCancelEditClick();
                }
                this.aboutBusinessEditClick();
              }}
            />
          </div>
        )}
      </div>
    );
  }
}
const checkForDifferentAddressType = (selectedType, type) =>
  selectedType === DIFFERENT_ADDRESS_TYPE ? type : selectedType;
const getSpittedAddress = (value) => {
  return value.split(',').reduce((p = '', val) => {
    return (
      <span>
        {p} <br />
        {val}
      </span>
    );
  });
};
export default AboutYourBusinessAccordionItem;
